import React from 'react';

export default {
	'Error.Unknown': 'Onbekende fout',
	'Error.Unknown.Message': 'Er is een fout opgetreden.',
	'Error.NotFound': 'Niet gevonden',
	'Error.NotFound.Message': 'De opgevraagde pagina kon niet gevonden worden.',
	'Error.Forbidden': 'Verboden',
	'Error.Forbidden.Message': 'U heeft geen toegang tot deze pagina.',
	'Error.Invalid': 'Ongeldige invoer',
	'Error.Invalid.Message': 'Ongeldige velden: {{fields}}.',
	'Error.FileSize.Message': 'Het bestand dat u probeerde te uploaden was te groot.',
	'PTMD Portal': 'PTMD Portaal',
	'Login': 'Login',
	'Logout': 'Uitloggen',
	'FileDrop.Release': 'Laat los om een bestand te selecteren',
	'FileDrop.Drag': () => <h5>Sleep een bestand hierheen<br/> of </h5>,
	'FileDrop.Select': 'Selecteer een bestand',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} bytes',
	'FileSize.Max': 'De maximale uploadgrootte is {{size}}',
	'Modal.Open': 'Open',
	'Modal.Close': 'Sluiten',
	'Language': 'Taal'
};
